/** Closed set of loan facts the product knows how to resolve. */
export const LOAN_FACT_CODES = [
  'reserves_months',
  'max_loan_amount',
] as const

export type LoanFactCode = (typeof LOAN_FACT_CODES)[number]

const FACT_CODE_SET: ReadonlySet<string> = new Set(LOAN_FACT_CODES)

export function isLoanFactCode(value: string): value is LoanFactCode {
  return FACT_CODE_SET.has(value)
}
